exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-notification {\n  position: fixed;\n  top: calc(96px + 16px);\n  right: 16px;\n  z-index: 99;\n  background-color: #00C51F !important;\n  color: #fff;\n  max-width: 600px;\n  border-radius: 6px;\n  padding: 16px !important;\n  border: 0 !important;\n  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.25); }\n  .task-notification .alert__content {\n    padding-left: 0;\n    padding-top: 0;\n    padding-bottom: 0; }\n    .task-notification .alert__content h5 {\n      color: #fff !important;\n      margin-bottom: 4px;\n      font-size: 14px;\n      font-weight: 600; }\n", ""]);

// exports
